module.exports = __webpack_public_path__ + "static/img/55817_0_dziecko ze smartfonem25_out.00f94f05.png";